import { BaseMapper } from '@ps/utils';
import { MultiBuyerEntityDto } from '../dtos/user-company.dto';
import { MultiBuyerEntity } from '../../models/multi-buyer-entity.model';

export class MultiBuyerEntityMapper extends BaseMapper<
  MultiBuyerEntityDto,
  MultiBuyerEntity
> {
  public fromDto(dto: MultiBuyerEntityDto): MultiBuyerEntity {
    return {
      id: dto.id,
      name: dto.nm,
      userId: dto.userId,
      apiUserId: dto.apiUserId,
    };
  }
}
